import React, { lazy, Suspense } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

import history from './history';

import Footer from './components/Footer';
import Header from './components/Header';
import Index from './modules/providerSearch/index';
import Store from './redux/Store';
import ErrorPage from './modules/errorPage/ErrorPage';
import ErrorBounary from './ErrorBounary';
import LoadingSpinner from './components/LoadingSpinner';
import '../public/scss/App.scss';

const ProviderList = lazy(() => import('./modules/providerList'));
const ProviderDetails = lazy(() => import('./modules/providerList/ProviderDetails'));
const FacilityDetails = lazy(() => import('./modules/providerList/FacilityDetails'));

function App() {
    return (
        <>
            <Header />
            <Provider store={Store}>
                <ConnectedRouter history={history}>
                    <BrowserRouter>
                        <Switch>
                            <Route exact path="/">
                                <ErrorBounary>
                                    <Index />
                                </ErrorBounary>
                            </Route>
                            <Route exact path="/providerList">
                                <ErrorBounary>
                                    {/* <ProviderList /> */}
                                    <Suspense fallback={<LoadingSpinner />}>
                                        <ProviderList />
                                    </Suspense>
                                </ErrorBounary>
                            </Route>
                            <Route exact path="/providerList/facility/(\d+)/">
                                <ErrorBounary>
                                    <Suspense fallback={<LoadingSpinner />}>
                                        <FacilityDetails />
                                    </Suspense>
                                </ErrorBounary>
                            </Route>
                            <Route exact path="/providerList/provider/(\d+)/">
                                <ErrorBounary>
                                    <Suspense fallback={<LoadingSpinner />}>
                                        <ProviderDetails />
                                    </Suspense>
                                </ErrorBounary>
                            </Route>
                            <Route path="*"><ErrorPage /></Route>
                        </Switch>
                    </BrowserRouter>
                </ConnectedRouter>
            </Provider>
            <Footer />
        </>
    );
}

export default App;
